import React from 'react';
import Navbar from '../Components/Navbar';
import Hero from '../Components/Hero';
import Services from '../Components/Services';
import MissionVision from '../Components/MissionVision';
import Testimonials from '../Components/Testimonials';
import Clients from '../Components/Clients';
import Contact from '../Components/Contact';
import Footer from '../Components/Footer';

const Homepage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <MissionVision />
      <Testimonials />
      <Clients />
      <Contact />
      <Footer />
    </div>
  );
};

export default Homepage;